import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'

import '@/assets/css/reset.css'
import '@/assets/css/main.css'
import i18n from './assets/i18n'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import routes from './router'


const app = createApp(App)
const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        // 每次路由切换时滚动到页面顶部
        return { top: 0 };
    }
})
app.use(i18n) // 注入 i18n
app.use(ElementPlus)
app.use(router)
app.mount('#app')
